<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'after-sale-status.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Status</th>
                                        <th>Finalizar o pós venda?</th>
                                        <th>Deve transferir o pós venda?</th>
                                        <th>Finalizar automaticamente?</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-show="items.length > 0"
                                        v-for="iterator in items" 
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>{{ iterator.status }}</td>
                                        <td>{{ iterator.finish_after_sale ? 'Sim' : 'Não' }}</td>
                                        <td>{{ iterator.must_transfer_formalization ? 'Sim' : 'Não' }}</td>
                                        <td>{{ iterator.auto_finish ? 'Sim' : 'Não' }}</td>
                                        <td class="td-actions text-right">
                                            <index-buttons
                                                :iterator=iterator
                                                :showAudit="false"
                                                :toAudit="{name: 'after-sale-status'}"
                                                :showEdit="true"
                                                :toEdit="{name: 'after-sale-status.edit', params: { id: iterator.id }}"
                                                :showRemove="true"
                                                dispatchRemove="after_sale_status/rem"
                                                :callbackRemove="getData"
                                                >
                                            </index-buttons>
                                        </td>
                                    </tr>
                                    <tr v-show="items.length==0">
                                        <td colspan="5">Nenhuma status de formalização encontrada!</td>
                                    </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        computed: {
            items() {
                return this.$store.state.after_sale_status.itens;
            }
        },
        created: function () {
            this.getData();
        },
        data() {
            return {
                currentPage: 1
            };
        },
        methods: {
            remove: function (_item) {
                var self = this;
                this.$dialog.confirm('Deseja realmente remover o status de pós venda "' + _item.status + '"?')
                        .then(function () {
                            self.$root.$emit('onLoading');

                            const response = self.$store.dispatch('after_sale_status/rem', _item);

                            response.then(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.success("Status de pós venda excluída com sucesso!");
                                self.getData();
                            });

                            response.catch(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.danger("Não foi possível excluir o status de pós venda!");
                            });
                        });
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('after_sale_status/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
        }
    }
</script>